import { UptimeSelectbox } from '@uptime/uptime-component';
import { UserInfo } from 'models';
import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GenerateDataTranslation } from 'utils/translation';

export interface SearchUserProps {
  onSelect: (user: UserInfo) => void;
  userOptionList: UserInfo[];
}

const SearchUser = (props: SearchUserProps) => {
  const { onSelect, userOptionList} = props;
  useTranslation('home');
  const [userSelected, setUserSelected] = useState<UserInfo | null>(null);

  const homeTranslation = GenerateDataTranslation('home');
  const searchUserTranslation = homeTranslation?.onBehalfOf?.modal?.searchUser || {};

  const [loading, setLoading] = useState(false);
  const [userOptions, setUserOptions] = useState<UserInfo[]>(userOptionList);

  const handleSearchChange = (value: string) => {
    setLoading(true);
    setUserOptions(userOptionList);
    const onChangeOption = userOptionList;
    const filteredUserOption = onChangeOption
    .filter(item => item.name.toLowerCase().toLocaleLowerCase().includes(value.toLowerCase()) || item.email.toLowerCase().toLocaleLowerCase().includes(value.toLowerCase()))
    .sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    setUserOptions(filteredUserOption);
    setLoading(false);
  };

  const handleSelect = (e: ChangeEvent, value: UserInfo) => {
    if (!value?.name) return;
    onSelect(value);
    setUserSelected(value);
  };

  return (
    <UptimeSelectbox
      data-user_email={userSelected?.email}
      loading={loading}
      options={userOptions}
      required
      boldLabel
      fullWidth
      valueKey="uid"
      clearOnBlur={false}
      handleSearchChange={handleSearchChange}
      handleChange={handleSelect}
      locale={searchUserTranslation}
      inputProps={{
        id: 'dv-search_user-input',
        'data-user_email': userSelected?.email || '',
      }}
    />
  );
};

export default SearchUser;
